import { get } from 'lodash';
import { pushToArrayProp, spliceArrayProp } from 'utils/seamlessUtils';

/**
 * does addition (select) for item not already selected
 * does removal (unselect) for item already selected
 */
const updateStateSelection = (state, payload, listPath, index) => {
  let result;

  if (state.asMutable) {
    result = ~index
      ? spliceArrayProp(state, listPath, index) // remove if present
      : pushToArrayProp(state, listPath, payload.id); // add if not present
  } else {
    const selected = get(state, listPath);

    if (~index) {
      selected.splice(index, 1);
    } else {
      selected.push(payload.id);
    }
  }

  return result || state;
};

const doSelection = (state, { payload }) => (payload.id ? updateStateSelection(state, payload, 'selected', state.selected.indexOf(payload.id)) : state);

const doListsSelection = (state, { payload }) => {
  if (payload.id) {
    const context = payload.params[0];
    const selIndex = state.lists[context].selected.indexOf(payload.id);

    state = updateStateSelection(state, payload, ['lists', context, 'selected'], selIndex);
  }

  return state;
};

/**
 * only does addition (select) for ids not already selected
 * doesnt do removal (unselect)
 */
const updateStateMultiSelection = (state, ids, listPath) => {
  const filtered = ids.filter((id) => !~get(state, listPath).indexOf(id)); // filter to only the ones not already selected
  let result;

  if (filtered.length) {
    if (state.asMutable) {
      result = pushToArrayProp(state, listPath, filtered);
    } else {
      const selected = get(state, listPath);
      selected.splice(selected.length, 0, ...filtered);
    }
  }

  return result || state;
};

const doMultipleSelection = (state, { payload }) => updateStateMultiSelection(state, payload.ids, ['selected']);

const doListsMultipleSelection = (state, { payload }) => updateStateMultiSelection(state, payload.ids, ['lists', payload.params[0], 'selected']);

export { doSelection, doMultipleSelection, doListsSelection, doListsMultipleSelection };
